module.exports = "table{width:100%;margin-bottom:20px}mat-spinner{margin:auto}.filters{padding-top:20px}.clickable{cursor:pointer}\n"